import React from "react";
import { Tooltip } from "react-tooltip";
import { FaQuestionCircle } from "react-icons/fa";
import { InvoiceDetails, tooltipContent } from "../../../../../locales/en";
import { formatCurrencyAmount } from "../../../../../utils/utils";
import { CURRENCY_FORMAT } from "../../../../../utils/constants/appConstants";

// repaymentExtensionDays: the customer's own limit, from getRepaymentExtensionDays
export const getColumns = (
  refferalParrtner,
  promoCodeSubmit,
  repaymentExtensionDays
) => {
  const baseColumns = [
    {
      Header: "Invoice Number",
      Footer: "Invoice Number",
      accessor: "invoiceNumber"
    },
    {
      Header: (
        <>
          <span id="repay-date-tooltip">
            {InvoiceDetails.paymentSection.paymentModal.rePaymentDate}
          </span>
          <span
            data-tooltip-id="fundedInvcs"
            className="ms-2"
            data-tooltip-content={`${tooltipContent.content1}${repaymentExtensionDays}${tooltipContent.content1End}`}
          >
            <FaQuestionCircle />
          </span>
          <Tooltip id="fundedInvcs" className="report_tooltip" />
        </>
      ),
      Footer: "Repayment Date",
      accessor: "dueDate"
    },
    {
      Header: "Advance",
      Footer: "Advance",
      accessor: "advanceAmount",
      Cell: ({ value }) => {
        return formatCurrencyAmount(value, CURRENCY_FORMAT);
      }
    },
    {
      Header: "Fee",
      Footer: "Fee",
      accessor: "feeAmount",
      Cell: ({ value }) => {
        return formatCurrencyAmount(value, CURRENCY_FORMAT);
      }
    }
  ];

  const referralColumns = [
    {
      Header: "Discount",
      Footer: "Discount",
      accessor: "feeSaved",
      Cell: ({ value }) => {
        return formatCurrencyAmount(value, CURRENCY_FORMAT);
      }
    },
    {
      Header: "Total Fee",
      Footer: "Total Fee",
      accessor: "totalFee",
      Cell: ({ value, row }) => {
        const feeToShow = value && value !== 0 ? value : row.original.feeAmount;
        return formatCurrencyAmount(feeToShow, CURRENCY_FORMAT);
      }
    }
  ];

  return refferalParrtner || promoCodeSubmit === true
    ? [...baseColumns, ...referralColumns]
    : baseColumns;
};
